import { salesPointConfigurationSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import { currencySymbolMap } from '@/utils/currencySymbolMap';

const useConfiguredCurrency = () => {
  const salesPointConfiguration = useSelector(salesPointConfigurationSelector);

  const currency = salesPointConfiguration?.currencies?.[0];

  if (!currency) {
    throw new Error('Currency configuration not found.');
  }

  return {
    currency,
    currencySymbol: currencySymbolMap[currency],
  };
};

export default useConfiguredCurrency;
